import React, { useEffect, useState } from "react";
import Navbar from "../components/Navbar";
import Footer from "../components/Footer";
import Portfolio from "../components/Portfolio";
import { api } from "../lib/api";

export default function PortfolioPage() {
  const [projects, setProjects] = useState([]);
  const [content, setContent] = useState({});
  useEffect(() => {
    Promise.all([api.getProjects(), api.getContent()])
      .then(([p, c]) => {
        setProjects(p || []);
        setContent(c || {});
      })
      .catch((err) => console.error("Portfolio page failed to load:", err));
  }, []);

  return (
    <div className="min-h-screen bg-onyx-900 text-ivory" data-testid="portfolio-page">
      <Navbar />
      <div className="pt-32 pb-12 text-center">
        <span className="font-cinzel text-[11px] tracking-[0.4em] uppercase text-gold">
          The Complete Reel
        </span>
        <h1 className="mt-4 font-display text-5xl md:text-7xl text-ivory">All <span className="italic text-gold-gradient">Works</span></h1>
        <p className="mt-4 max-w-xl mx-auto px-6 text-ivory/65">
          Every music video, commercial and short film delivered by Dhadda Motion Pictures.
        </p>
      </div>
      <Portfolio projects={projects} mode="grid" showHeader={false} />
      <Footer contact={content.contact || {}} settings={content.settings || {}} />
    </div>
  );
}
